import { motion } from 'framer-motion';
import ShieldIcon from '@mui/icons-material/ShieldOutlined';
import CheckIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import TouchIcon from '@mui/icons-material/TouchAppOutlined';
import TaskIcon from '@mui/icons-material/TaskOutlined';

const Why = () => {
  return (
    <>
      {/* Why Use Integritas Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="relative p-8 mb-8 bg-core-black-100 border border-core-black-contrast-2 rounded-[24px]"
      >
        <h3 className="text-[24px] mb-4 text-minima-orange-2023">Why use Integritas?</h3>
        {/* <p className="mb-6">IMAGE HERE</p> */}
        <div className="ml-6">
          <ul className="list-none mb-6 flex flex-col gap-6">
            <li className="flex items-start">
              <ShieldIcon className="w-10 h-10 text-[#ff8630] mr-4 flex-shrink-0" />
              <div className="ml-2">
                <strong>Tamper-proof:</strong> Leverages blockchain technology to ensure data
                integrity and prevent manipulation of data.
              </div>
            </li>
            <li className="flex items-start">
              <CheckIcon className="w-10 h-10 text-[#ff8630] mr-4 flex-shrink-0" />
              <div className="ml-2">
                <strong>Automated Accuracy Checks:</strong> Compares data against stored records
                providing real-time verification.
              </div>
            </li>
            <li className="flex items-start">
              <TouchIcon className="w-10 h-10 text-[#ff8630] mr-4 flex-shrink-0" />
              <div className="ml-2">
                <strong>Simplicity:</strong> A seamless App that makes it simple to upload data,
                view past uploads, and access detailed verification reports.
              </div>
            </li>
            <li className="flex items-start">
              <TaskIcon className="w-10 h-10 text-[#ff8630] mr-4 flex-shrink-0" />
              <div className="ml-2">
                <strong>Secure & verifiable reports:</strong> Generates verifiable reports stored
                immutably on the blockchain for trust and compliance.
              </div>
            </li>
          </ul>
        </div>
      </motion.div>
    </>
  );
};
export default Why;
